// extracted by mini-css-extract-plugin
export default {"summary-wrapper":"summary_summary-wrapper__rCxLm","summary-description":"summary_summary-description__gOBza","summary-metrics":"summary_summary-metrics__-qjAV"};